import { render, staticRenderFns } from "./WidgetsDialogs.vue?vue&type=template&id=220cc4f5&"
import script from "./WidgetsDialogs.vue?vue&type=script&lang=js&"
export * from "./WidgetsDialogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports